/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CreateTablesFromGoldStandardRequest from '../model/CreateTablesFromGoldStandardRequest';
import CreateTablesFromGoldStandardResponse from '../model/CreateTablesFromGoldStandardResponse';
import GetSavedAnnotationAdditionalContentResponse from '../model/GetSavedAnnotationAdditionalContentResponse';
import GetTableAnnotationResponse from '../model/GetTableAnnotationResponse';
import GetTablePreProcessingResponse from '../model/GetTablePreProcessingResponse';
import GetTableResponse from '../model/GetTableResponse';
import PatchTableRequest from '../model/PatchTableRequest';
import SaveAnnotationAdditionalContentRequest from '../model/SaveAnnotationAdditionalContentRequest';
import TableInTableList from '../model/TableInTableList';

/**
* Table service.
* @module endpoints/TableApi
* @version 2.8.0
*/
export default class TableApi {

    /**
    * Constructs a new TableApi. 
    * @alias module:endpoints/TableApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Create a new table in an user's project and launch preProcessing on it.
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} name 
     * @param {String} path 
     * @param {File} file 
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.pipedTasks Tasks launched when this table is created
     * @param {String} opts.projectCollection 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTableResponse} and HTTP response
     */
    createTableWithHttpInfo(userId, projectId, name, path, file, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createTable");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling createTable");
      }
      // verify the required parameter 'name' is set
      if (name === undefined || name === null) {
        throw new Error("Missing the required parameter 'name' when calling createTable");
      }
      // verify the required parameter 'path' is set
      if (path === undefined || path === null) {
        throw new Error("Missing the required parameter 'path' when calling createTable");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling createTable");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId
      };
      let queryParams = {
        'pipedTasks': opts['pipedTasks']
      };
      let headerParams = {
      };
      let formParams = {
        'name': name,
        'path': path,
        'projectCollection': opts['projectCollection'],
        'file': file
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = GetTableResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create a new table in an user's project and launch preProcessing on it.
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} name 
     * @param {String} path 
     * @param {File} file 
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.pipedTasks Tasks launched when this table is created
     * @param {String} opts.projectCollection 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTableResponse}
     */
    createTable(userId, projectId, name, path, file, opts) {
      return this.createTableWithHttpInfo(userId, projectId, name, path, file, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Create tables in an user's project from Gold Standard
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {module:model/CreateTablesFromGoldStandardRequest} createTablesFromGoldStandardRequest Create tables from Gold Standard input
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.pipedTasks Tasks launched when this table is created
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateTablesFromGoldStandardResponse} and HTTP response
     */
    createTablesFromGoldStandardWithHttpInfo(userId, projectId, createTablesFromGoldStandardRequest, opts) {
      opts = opts || {};
      let postBody = createTablesFromGoldStandardRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createTablesFromGoldStandard");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling createTablesFromGoldStandard");
      }
      // verify the required parameter 'createTablesFromGoldStandardRequest' is set
      if (createTablesFromGoldStandardRequest === undefined || createTablesFromGoldStandardRequest === null) {
        throw new Error("Missing the required parameter 'createTablesFromGoldStandardRequest' when calling createTablesFromGoldStandard");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId
      };
      let queryParams = {
        'pipedTasks': opts['pipedTasks']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateTablesFromGoldStandardResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/createTablesFromGoldStandard', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create tables in an user's project from Gold Standard
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {module:model/CreateTablesFromGoldStandardRequest} createTablesFromGoldStandardRequest Create tables from Gold Standard input
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.pipedTasks Tasks launched when this table is created
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateTablesFromGoldStandardResponse}
     */
    createTablesFromGoldStandard(userId, projectId, createTablesFromGoldStandardRequest, opts) {
      return this.createTablesFromGoldStandardWithHttpInfo(userId, projectId, createTablesFromGoldStandardRequest, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Delete table of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    deleteTableWithHttpInfo(userId, projectId, tableId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling deleteTable");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling deleteTable");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling deleteTable");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Delete table of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    deleteTable(userId, projectId, tableId) {
      return this.deleteTableWithHttpInfo(userId, projectId, tableId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get annotation result
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTableAnnotationResponse} and HTTP response
     */
    getAnnotationResultWithHttpInfo(userId, projectId, tableId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getAnnotationResult");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling getAnnotationResult");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling getAnnotationResult");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetTableAnnotationResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}/annotation/result', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get annotation result
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTableAnnotationResponse}
     */
    getAnnotationResult(userId, projectId, tableId) {
      return this.getAnnotationResultWithHttpInfo(userId, projectId, tableId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get preprocessing result
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTablePreProcessingResponse} and HTTP response
     */
    getPreProcessingResultWithHttpInfo(userId, projectId, tableId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getPreProcessingResult");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling getPreProcessingResult");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling getPreProcessingResult");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetTablePreProcessingResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}/preprocessing/result', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get preprocessing result
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTablePreProcessingResponse}
     */
    getPreProcessingResult(userId, projectId, tableId) {
      return this.getPreProcessingResultWithHttpInfo(userId, projectId, tableId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get saved annotation additional content
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetSavedAnnotationAdditionalContentResponse} and HTTP response
     */
    getSavedAnnotationAdditionalContentWithHttpInfo(userId, projectId, tableId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getSavedAnnotationAdditionalContent");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling getSavedAnnotationAdditionalContent");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling getSavedAnnotationAdditionalContent");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetSavedAnnotationAdditionalContentResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}/annotation/savedAdditionalContent', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get saved annotation additional content
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetSavedAnnotationAdditionalContentResponse}
     */
    getSavedAnnotationAdditionalContent(userId, projectId, tableId) {
      return this.getSavedAnnotationAdditionalContentWithHttpInfo(userId, projectId, tableId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get table of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.withRefresh Refresh pre processing and annotation status before replying
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTableResponse} and HTTP response
     */
    getTableWithHttpInfo(userId, projectId, tableId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getTable");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling getTable");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling getTable");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
        'withRefresh': opts['withRefresh']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetTableResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get table of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.withRefresh Refresh pre processing and annotation status before replying
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTableResponse}
     */
    getTable(userId, projectId, tableId, opts) {
      return this.getTableWithHttpInfo(userId, projectId, tableId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get tables of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.withRefresh Refresh pre processing and annotation status before replying
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TableInTableList>} and HTTP response
     */
    getTablesWithHttpInfo(userId, projectId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getTables");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling getTables");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId
      };
      let queryParams = {
        'withRefresh': opts['withRefresh']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [TableInTableList];
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get tables of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.withRefresh Refresh pre processing and annotation status before replying
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TableInTableList>}
     */
    getTables(userId, projectId, opts) {
      return this.getTablesWithHttpInfo(userId, projectId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Launch annotation task
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTableResponse} and HTTP response
     */
    launchAnnotationWithHttpInfo(userId, projectId, tableId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling launchAnnotation");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling launchAnnotation");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling launchAnnotation");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetTableResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}/annotation', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Launch annotation task
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTableResponse}
     */
    launchAnnotation(userId, projectId, tableId) {
      return this.launchAnnotationWithHttpInfo(userId, projectId, tableId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * reLaunch preProcessing task
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTableResponse} and HTTP response
     */
    launchPreProcessingWithHttpInfo(userId, projectId, tableId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling launchPreProcessing");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling launchPreProcessing");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling launchPreProcessing");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetTableResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}/preprocessing', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * reLaunch preProcessing task
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTableResponse}
     */
    launchPreProcessing(userId, projectId, tableId) {
      return this.launchPreProcessingWithHttpInfo(userId, projectId, tableId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Patch table of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @param {module:model/PatchTableRequest} patchTableRequest Patch table input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTableResponse} and HTTP response
     */
    patchTableWithHttpInfo(userId, projectId, tableId, patchTableRequest) {
      let postBody = patchTableRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling patchTable");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling patchTable");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling patchTable");
      }
      // verify the required parameter 'patchTableRequest' is set
      if (patchTableRequest === undefined || patchTableRequest === null) {
        throw new Error("Missing the required parameter 'patchTableRequest' when calling patchTable");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = GetTableResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Patch table of an user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @param {module:model/PatchTableRequest} patchTableRequest Patch table input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTableResponse}
     */
    patchTable(userId, projectId, tableId, patchTableRequest) {
      return this.patchTableWithHttpInfo(userId, projectId, tableId, patchTableRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Save annotation additional content
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @param {module:model/SaveAnnotationAdditionalContentRequest} saveAnnotationAdditionalContentRequest Save annotation additional content input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetSavedAnnotationAdditionalContentResponse} and HTTP response
     */
    saveAnnotationAdditionalContentWithHttpInfo(userId, projectId, tableId, saveAnnotationAdditionalContentRequest) {
      let postBody = saveAnnotationAdditionalContentRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling saveAnnotationAdditionalContent");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling saveAnnotationAdditionalContent");
      }
      // verify the required parameter 'tableId' is set
      if (tableId === undefined || tableId === null) {
        throw new Error("Missing the required parameter 'tableId' when calling saveAnnotationAdditionalContent");
      }
      // verify the required parameter 'saveAnnotationAdditionalContentRequest' is set
      if (saveAnnotationAdditionalContentRequest === undefined || saveAnnotationAdditionalContentRequest === null) {
        throw new Error("Missing the required parameter 'saveAnnotationAdditionalContentRequest' when calling saveAnnotationAdditionalContent");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'tableId': tableId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = GetSavedAnnotationAdditionalContentResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/tables/{tableId}/annotation/savedAdditionalContent', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Save annotation additional content
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} tableId Id of the table
     * @param {module:model/SaveAnnotationAdditionalContentRequest} saveAnnotationAdditionalContentRequest Save annotation additional content input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetSavedAnnotationAdditionalContentResponse}
     */
    saveAnnotationAdditionalContent(userId, projectId, tableId, saveAnnotationAdditionalContentRequest) {
      return this.saveAnnotationAdditionalContentWithHttpInfo(userId, projectId, tableId, saveAnnotationAdditionalContentRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
